type RelativeDates = {
  today: string
  thirtyDaysFuture: string
}

export const relativeDates = (): RelativeDates => {
  const today = new Date()
  const thirtyDaysFuture = new Date()
  thirtyDaysFuture.setDate(today.getDate() + 30)
  return {
    today: today.toISOString().substring(0, 10),
    thirtyDaysFuture: thirtyDaysFuture.toISOString().substring(0, 10),
  }
}
